import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CampaignUmbrellaListRBAC = {
  pageID: 'e532afa81283de7861660cc417f49b4b',
  elementID: {
    ViewPage: 'd43954a1d0ad8e03f7c86da73c591dbd',
    Create: '2f706e5e74b4777c0a3a56d0a8030173',
    Detail: 'f0e95fa4bb6b311239ac66a28ea36464',
    Edit: '53531567317ea146a84f2e4540d14d47',
    Delete: '5d0e61a474981ad71f899925ebf09fc6',
  },
} as const

export const useRBACCampaignUmbrellaListRBAC = createUseRBAC(CampaignUmbrellaListRBAC.elementID)

export type UseRBACCampaignUmbrellaListRolesPageType = ReturnType<
  typeof useRBACCampaignUmbrellaListRBAC
>
